import React, { useState } from 'react';
import TextFieldMask from './TextFieldMask';
import { unMask } from '../../../commons/masks';

const Mask = { phone1: '(99) 9999-99999', phone2: '(99) 9-9999-9999' };

const PhoneField = (props) => {
  const { name, label, value, onChange, focus=false, ...other } = props;
  const [mask, setMask] = useState( unMask(value).length > 10 ? Mask.phone2 : Mask.phone1 );

  return (
    <TextFieldMask 
      label={label}
      name={name}
      mask={mask}
      value={value}
      onChange={e => {
        setMask( unMask(e.target.value).length > 10 ? Mask.phone2 : Mask.phone1 );
        onChange(e);
      }}
      focus={focus}
      {...other}
    />
  )

}

export default PhoneField;
